import { render } from 'solid-js/web'

import './index.css'

import { Router, Route } from "@solidjs/router";
import { lazy } from "solid-js";
import App from "./App";
import { AuthLayout, DashboardLayout } from "./layout";
import axios from "axios";

axios.defaults.baseURL = import.meta.env.VITE_API_ENDPOINT;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';

// Lazy load auth pages
const Login = lazy(() => import('./pages/auth/login'));
const ForgetPassword = lazy(() => import('./pages/auth/forget'));
const RecoverPassword = lazy(() => import('./pages/auth/recover'));

// Lazy load main pages
const Home = lazy(() => import('./pages/home/index'));
const History = lazy(() => import('./pages/history/list'));
const CaseAppointments = lazy(() => import('./pages/history/appointments/list'));
const ProfileUpdate = lazy(() => import('./pages/profile/update'));
const Checkup = lazy(() => import('./pages/checkup/index'));

// Lazy load administrator pages
const AdministratorList = lazy(() => import('./pages/administrator/list'));
const AdministratorForm = lazy(() => import('./pages/administrator/form'));

// Lazy load receptionist pages
const ReceptionistList = lazy(() => import('./pages/receptionist/list'));
const ReceptionistForm = lazy(() => import('./pages/receptionist/form'));

// Lazy load doctor pages
const DoctorList = lazy(() => import('./pages/doctor/list'));
const DoctorForm = lazy(() => import('./pages/doctor/form'));

// Lazy load other pages
const AppointmentList = lazy(() => import('./pages/appointment/list'));
const PaymentList = lazy(() => import('./pages/payment/list'));
const RoomList = lazy(() => import('./pages/room/list'));
const DutyList = lazy(() => import('./pages/duty/list'));
const PatientList = lazy(() => import('./pages/patient/list'));
const DiagnosisList = lazy(() => import('./pages/diagnosis/list'));
const ComplaintList = lazy(() => import('./pages/complaint/list'));
const TestList = lazy(() => import('./pages/test/list'));
const QuestionList = lazy(() => import('./pages/question/list'));

// Lazy load therapy pages
const TherapyList = lazy(() => import('./pages/therapy/list'));
const TherapyForm = lazy(() => import('./pages/therapy/form'));
const SessionList = lazy(() => import('./pages/session/list'));
const SessionForm = lazy(() => import('./pages/session/form'));

const AppRouter = () => {
  return (
    <Router root={App}>
      <Route path="auth" component={AuthLayout}>
        <Route path="login" component={Login} />
        <Route path="forget-password" component={ForgetPassword} />
        <Route path="recover-password" component={RecoverPassword} />
      </Route>
      <Route path="/" component={DashboardLayout}>
        <Route path="" component={Home} />
        <Route path="home" component={Home} />
        <Route path="profile" component={ProfileUpdate} />
        <Route path="checkup" component={Checkup} />
        <Route path="history" component={History} />
        <Route path="case/:key/appointments" component={CaseAppointments} />

        {/* Administrator routes */}
        <Route path="administrators" component={AdministratorList} />
        <Route path="administrator/create" component={AdministratorForm} />
        <Route path="administrator/:key/edit" component={AdministratorForm} />

        {/* Receptionist routes */}
        <Route path="receptionists" component={ReceptionistList} />
        <Route path="receptionist/create" component={ReceptionistForm} />
        <Route path="receptionist/:key/edit" component={ReceptionistForm} />

        {/* Doctor routes */}
        <Route path="doctors" component={DoctorList} />
        <Route path="doctor/create" component={DoctorForm} />
        <Route path="doctor/:key/edit" component={DoctorForm} />

        <Route path="appointments" component={AppointmentList} />
        <Route path="payments" component={PaymentList} />
        <Route path="rooms" component={RoomList} />
        <Route path="duties" component={DutyList} />
        <Route path="diagnoses" component={DiagnosisList} />
        <Route path="complaints" component={ComplaintList} />
        <Route path="tests" component={TestList} />
        <Route path="questions" component={QuestionList} />
        <Route path="patients" component={PatientList} />

        {/* Therapy routes */}
        <Route path="therapies" component={TherapyList} />
        <Route path="therapy/create" component={TherapyForm} />
        <Route path="therapy/:key/edit" component={TherapyForm} />
        <Route path="therapy/:therapy/sessions" component={SessionList} />
        <Route path="therapy/:therapy/session/create" component={SessionForm} />
        <Route path="therapy/:therapy/session/:key/edit" component={SessionForm} />
      </Route>
    </Router>
  );
}

render(
  () => <AppRouter />,
  document.getElementById('root')
);
